import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  deleteEmailModule,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";

export class DeleteEmailModuleModal extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, emailModule } = this.props;

    this.props
      .deleteEmailModule(accountId, emailModule.id)
      .then(this.props.closeModal);
  }

  render() {
    const { emailModule } = this.props;
    const content = emailModule?.name
      ? `Remove ${emailModule.name}`
      : "Removing";

    return (
      <Modal>
        <ModalHeader>Delete Email?</ModalHeader>
        <ModalContent>{content}</ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.delete}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

DeleteEmailModuleModal.propTypes = {
  emailModule: PropTypes.object.isRequired,
  deleteEmailModule: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const emailModule = state.entities.emailModule[id];

  return {
    accountId,
    id,
    emailModule,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  deleteEmailModule,
  emailTemplatesList,
  gotoUrl,
})(DeleteEmailModuleModal);
